import React from 'react';
import classNames from 'classnames';

const Select = props => {
    return (
        <div className={classNames({
            'form__select': true,
            ...props.modifiers
        })}>
            <select name={props.name} onChange={props.onChange} value={props.value}>
                {props.children}
            </select>
        </div>
    );
};

export default Select;